pageId = 'page-search-result'
page = '#' + pageId

target_filter = -1
target_type = null
member_filter = -1
category_filter = -1
sort_filter = 1

# 过滤重复请求
popover_map = {}
type_old = null
value_old = null

$ ->
  $(document)
  .on 'click', ".search-popover li a, #{page} .form-condition-search .search-btn", handleFilter
  .on 'tr-selector-field:change', ".member-selector", (event) -> filter('member', event.detail)
  .on 'tr-selector-field:change', ".target-selector", (event) -> filter('target', event.detail)
  .on 'change', ".exclude_trash", handleFilter
  .on 'submit', "#{page} .form-condition-search", handleFilter
  .on 'click', "#{page} #category-filter", ->
    popover_map['category'] = simple.popover
      pointTo: $('#category-filter')
      content: $('#tpl-category-filter').html()
      position: 'bottom-center'
      cls: 'dropdown-list no-arrow search-popover'
      offset:
        x: 0
        y: -14
  .on 'click', "#{page} .condition-sort", ->
    popover_map['sort'] = simple.popover
      pointTo: $('.condition-sort')
      content: $('#tpl-sort').html()
      position: 'bottom-center'
      cls: 'dropdown-list no-arrow search-popover scrollable'
      offset:
        x: 0
        y: -14

handleFilter = (evt) ->
  evt.preventDefault()
  target = $(@)
  type = target.data 'type'
  value = target.data 'value'
  filter(type, value)

filter = (type, value)->
  if type and type == type_old and value and value == value_old
    if type is 'category' or type is 'sort'
      popover_map[type].destroy()
      return
  else
    type_old = type
    value_old = value
  if type is 'target'
    target_filter = value
    target_type = type
  else if type is 'member'
    member_filter = value
  else if type is 'category'
    category_filter = value
  else if type is 'sort'
    sort_filter = value
  fetchResult()


fetchResult = ->
  url = simple.url()
  params = $('.form-condition-search').serializeObject()
  params['keyword'] = encodeURIComponent $.trim(params['keyword'])
  if target_filter != -1
      params['target_gid'] = encodeURIComponent $.trim(target_filter)
  if member_filter != -1
    params['member_guid'] = encodeURIComponent $.trim(member_filter)
  if category_filter != -1
    params['category'] = encodeURIComponent $.trim(category_filter)
  if sort_filter != 1
    params['sort'] = sort_filter
  params['exclude_trash'] = $('#exclude_trash').prop('checked')
  url.search = params
  tower.stack.load url.toString('relative'),
    nocache: true
    replace: true
  return false


$(document).on 'pjaxload#' + pageId, (e, $page, page) ->
  # 没有搜索结果的时候就不显示load more 按钮，所以也不需要执行后面的操作了
  return unless $('#btn-load-more').length

  tower.scrollLoad $page, (loadBtn) ->
    return $.ajax
      url: location.pathname + location.search
      dataType: "html"
      type: 'get'
      data:
        page: $('.results:last').data('page')*1 + 1
      success: (result) ->
        if result
          content = $(result).find('ul.results')
          loadBtn.before(content)
          hlKeyword(content)
          tower.adjustReadableTime(content)
  hlKeyword()


hlKeyword = (scope) ->
  keyword = $('.condition-keyword input[name=keyword]').val()
  return unless keyword

  # 用|替换搜索词间的空格或加号，保证正则准确
  keyword = keyword.replace(/\s+|\+/, "|")
  # 替换掉没用的 \，防止报错
  keyword = keyword.replace(/\\/g, '')
  scope or= $('ul.results')
  tagKeyword = [k.replace(/^#+/ig, '') for k in keyword.split('|')].join('|')

  re = new RegExp(keyword, 'ig')
  tagRe = new RegExp(tagKeyword, 'ig')
  matchNodes = []
  selector = '.main span, .main a:not(.tag), .main p:not(.result-project, .result-time)'

  scope.find(selector).each ->
    $.each this.childNodes, (idx, node) ->
      try
        if node.nodeType is 3 and node.nodeValue.match(re)
          matchNodes.push(node)

  $.each matchNodes, (idx, node) ->
    try
      txt = tower.encodeHtml(node.nodeValue).replace re, (match) ->
        return "<span class='match'>#{match}</span>"
      $(node).replaceWith(txt)

  $('.main .tag').each ->
    try
      if this.firstChild.nodeValue.match(tagRe)
        $(this).addClass('match')
